import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  name: 'María G.',
  initial: 'M',
  text: 'Las recetas fueron lo que más me ayudó. Todo es fácil de preparar y realmente me sentí mucho mejor.'
}, {
  name: 'Patricia L.',
  initial: 'P',
  text: 'La lista de compras me facilitó todo. Ya no tenía que pensar qué comprar cada semana.'
}, {
  name: 'Carmen R.',
  initial: 'C',
  text: 'Las bebidas son deliciosas. Fue lo que más me ayudó con la digestión.'
}, {
  name: 'Laura M.',
  initial: 'L',
  text: 'El plan completo hace que todo sea mucho más fácil de seguir.'
}];
export function TestimonialsCompact() {
  return <section className="py-16 bg-[#F2E8DA]/50 backdrop-blur-[2px]" data-id="element-214">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-215">
        <motion.h2 className="text-2xl md:text-3xl font-heading font-bold text-black text-center mb-10" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-216">
          Lo que dicen quienes ya lo tienen
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-217">
          {testimonials.map((testimonial, index) => <motion.div key={index} className="bg-white rounded-xl p-5 shadow-sm border border-beige" initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} data-id="element-218">
              <div className="flex items-center mb-2.5" data-id="element-219">
                <div className="w-9 h-9 rounded-full bg-sage text-white flex items-center justify-center font-heading font-semibold text-sm mr-3 flex-shrink-0" data-id="element-220">
                  {testimonial.initial}
                </div>
                <div data-id="element-221">
                  <div className="font-semibold text-text-dark text-sm" data-id="element-222">
                    {testimonial.name}
                  </div>
                  <div className="flex text-gold-soft" data-id="element-223">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3 h-3 fill-current" data-id="element-224" />)}
                  </div>
                </div>
              </div>
              <p className="text-text-medium italic text-sm leading-relaxed" data-id="element-225">
                "{testimonial.text}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}